export default "__VITE_PUBLIC_ASSET__de93f86c__"